import React, {Dispatch, SetStateAction} from 'react';
import {Root as DialogRoot} from '@radix-ui/react-dialog';
import Image from 'next/image';

import {LabResultMetricTypeEnum} from '#apollo/schema';
import {Button, Modal, Text} from '#component/base';
import {ModalClose} from '#component/base/Modal';
import {useViewportSize} from '#hook';

import * as css from './InformationModal.css';

export interface InformationModalProps {
  open: boolean;
  onOpenChange: Dispatch<SetStateAction<boolean>>;
  percentileType: LabResultMetricTypeEnum;
}

export function InformationModal({open, onOpenChange, percentileType}: InformationModalProps) {
  const {isMobile} = useViewportSize();

  const modalTitle =
    percentileType == LabResultMetricTypeEnum.TallyCohortAgePercentile
      ? 'Who are my peers?'
      : 'Who is everyone?';

  const generalImageUrlMobile =
    '/image/percentile-educational-drawer/everyone-percentile-education-mobile.png';
  const generalImageUrlDesktop =
    '/image/percentile-educational-drawer/everyone-percentile-education-desktop.png';
  const generalImageUrl = isMobile ? generalImageUrlMobile : generalImageUrlDesktop;

  const cohortImageUrlMobile =
    '/image/percentile-educational-drawer/cohort-percentile-education-mobile.png';
  const cohortImageUrlDesktop =
    '/image/percentile-educational-drawer/cohort-percentile-education-desktop.png';
  const cohortImageUrl = isMobile ? cohortImageUrlMobile : cohortImageUrlDesktop;

  const imageUrl =
    percentileType == LabResultMetricTypeEnum.TallyCohortAgePercentile
      ? cohortImageUrl
      : generalImageUrl;

  const generalInformationText =
    'We compare you to a large, diverse database of individual test results spanning a wide chronological age range.';
  const cohortInformationText =
    'Your peer comparison is based on others who have a similar chronological age and birth sex (if specified within your profile) as you.';

  const informationText =
    percentileType == LabResultMetricTypeEnum.TallyCohortAgePercentile
      ? cohortInformationText
      : generalInformationText;

  return (
    <DialogRoot open={open} onOpenChange={onOpenChange}>
      <Modal layout="narrowDrawer">
        <div>
          <div className={css.Header}>
            <Text color="black" className={css.Text}>
              {modalTitle}
            </Text>
            <Button icon="X" as={ModalClose} variant="secondary" />
          </div>
          <div className={css.Section}>
            <div className={css.InformationWrapper}>
              <Image
                src={imageUrl}
                width={isMobile ? 343 : 540}
                height={isMobile ? 244 : 306}
                alt="Information visualization"
                className={css.Image}
              />
            </div>
            <Text className={css.InformationText} color="black">
              {informationText}
            </Text>

            <Button
              variant="primary"
              style={{height: '55px', width: '328px', marginTop: '50px'}}
              className={css.Button}
              as={ModalClose}>
              Got it
            </Button>
          </div>
        </div>
      </Modal>
    </DialogRoot>
  );
}
